import React from 'react';

export default function TickIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="Artboard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="ic/check">
          <g>
            <mask id="mask-2-tick" fill="white">
              <polygon
                id="path"
                points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"></polygon>
            </mask>
            <g id="Path" fillRule="nonzero"></g>
            <g id="Green-/-G400" mask="url(#mask-2-tick)" fill="#00875A">
              <rect id="G400" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
